<template>
  <div v-if="editMode">
    <Button class="me-2" :noMargin="true" @click="$emit('cancel')">
      Cancel Editing
    </Button>
    <Button :noMargin="true" @click="$emit('save')">
      {{ processing ? "Please wait..." : "Save Changes" }}
    </Button>
  </div>
</template>

<script>
import Button from "../UI/Button.vue"

export default {
  components: { Button },
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
